export const DEFAULT_CURRENCY = 'RON'

type CurrencyFormatOptions = Omit<
  Intl.NumberFormatOptions,
  'style' | 'currency'
>

export const getIntlLocale = (language?: string) =>
  language === 'ro' ? 'ro-RO' : 'en-US'

export const createNumberFormatter = (
  locale: string,
  options: Intl.NumberFormatOptions = {}
) => new Intl.NumberFormat(locale, options)

export const createCurrencyFormatter = (
  locale: string,
  options: CurrencyFormatOptions = {}
) =>
  createNumberFormatter(locale, {
    style: 'currency',
    currency: DEFAULT_CURRENCY,
    ...options,
  })

export const createPercentFormatter = (
  locale: string,
  options: Omit<Intl.NumberFormatOptions, 'style'> = {}
) =>
  createNumberFormatter(locale, {
    style: 'percent',
    ...options,
  })

export const createDateFormatter = (
  locale: string,
  options: Intl.DateTimeFormatOptions
) => new Intl.DateTimeFormat(locale, options)
